import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useCallback, useRef, useState } from 'react';
import { CustomTileLayers } from 'shared/map/ui/components/tile-layers';
import { a2l } from 'shared/map/lib/utils';
import { AttributionControl, MapContainer } from 'react-leaflet';
import { DeviceMarkers } from 'entities/device.map.markers/ui/device-markers';
import { CornerNotice } from 'console/utils/corner-notice';
import { Box } from '@mui/material';
import { usePartial } from 'shared/hooks/utils';
import { pickDevice } from 'console/redux/main-actions';
import { closeMiniMap } from 'widgets/map.corner/model/actions';
import { useAction } from 'shared/hooks/redux/hooks';
import { getCrs } from 'shared/map/lib/get-crs';
export const CornerMap = memo(function CornerMap(props) {
    const { markers_info, device_id, provider, center, marker_size } = props;
    const onClickCloseMiniMap = usePartial(useAction(closeMiniMap), device_id);
    const [zoom, setZoom] = useState(15);
    const onClickZoomControl = useCallback((event) => {
        setZoom(event.target.getZoom());
    }, [setZoom]);
    const this_map = useRef(null);
    const onClickSelectDevice = useAction(usePartial(pickDevice, device_id));
    const onCloseMiniMap = useAction(usePartial(onClickCloseMiniMap, device_id));
    return (_jsx(CornerNotice, { title: `${markers_info.name}`, open: true, onClose: onCloseMiniMap, warning: false, padding: false, children: _jsx(Box, { width: "320px", height: "300px", position: "relative", children: _jsxs(MapContainer, { style: {
                    flexGrow: 1,
                    overflow: 'hidden',
                    zIndex: 0,
                    position: 'absolute',
                    top: '0',
                    left: '0',
                    width: '100%',
                    height: '100%',
                }, keyboard: false, zoom: zoom, attributionControl: false, zoomControl: true, crs: getCrs(provider), ref: this_map, center: a2l(markers_info.locations?.[0] ?? center), onzoom: onClickZoomControl, children: [_jsx(AttributionControl, { position: "bottomleft", prefix: "" }), _jsx(CustomTileLayers, {}), _jsx(DeviceMarkers, { markers_info: [markers_info], onClick: onClickSelectDevice, labels_visible: false, icon_size: marker_size })] }, getCrs(provider).code) }) }));
});
